<div class="table table-striped">
  <p-table #dt [value]="familiares" [rows]="10" [paginator]="true" [globalFilterFields]="['claseFamiliaNavigation.descripcion', 'apellido', 'nombre']" 
               [rowHover]="true" dataKey="id" 
               currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Familiares" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
      <div class="p-d-flex p-ai-center p-jc-between">
        <span class="p-input-icon-left">
          <!-- <i class="pi pi-search"></i> -->
          <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
        </span>
        <span class="p-input-icon">
          Vigencias del  
         <input pInputText type="date" [(ngModel)]="filtroDesde" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
          al  
         <input pInputText type="date" [(ngModel)]="filtroHasta" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
        </span>
        <mat-slide-toggle color="primary" [(ngModel)]="agrupar" (ngModelChange)="onChangeAgrupamiento()">Agrupar</mat-slide-toggle>
        <button *ngIf="permisoEdicion" type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="text-align: center;">Fecha Inicio</th>
        <th style="text-align: center;">Parentezco</th>
        <th style="text-align: center;">Apellido</th>
        <th style="text-align: center;">Nombre</th>
        <th style="text-align: center;">Email</th>
        <th style="text-align: center;">Contacto Emergencia</th>
        <th style="text-align: center;">Discapacitado</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-familiar let-rowIndex="rowIndex">
      <tr>
        <td style="text-align: center;">{{familiar.desde|date:'dd/MM/yyyy'}}</td>
        <td>{{familiar.claseFamiliaNavigation.descripcion}}</td>
        <td>{{familiar.apellido}}</td>
        <td>{{familiar.nombre}}</td>
        <td>{{familiar.email}}</td>
        <td class="text-center">
          <mat-checkbox [(ngModel)]="familiar.contactoEmergencia" [disabled]=true>            
          </mat-checkbox>
        </td>
        <td class="text-center">
          <mat-checkbox [(ngModel)]="familiar.discapacitado" [disabled]=true>
          </mat-checkbox>
        </td>
        <td>
          <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="visualizarDetalle(familiar, rowIndex)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
